// extracted by mini-css-extract-plugin
export default {"customer_avatar":"CustomerAvatar_customer_avatar__YTjA+"};